module.exports = __webpack_public_path__ + "static/media/notes_icon3.e250c16a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notes/notes_icon3.svg
// module id = 1040
// module chunks = 0